module.exports = __webpack_public_path__ + "static/media/g8.21c2b045.jpg";